import { Category } from './category';

export class Proposal {
  id: number;
  userEmail: string;
  userName: string;
  title: string;
  description: string;
  category: Category;
  totalVotes: number;
  userVotes: number;
  totalComments: number;
  idOpenSpace: number;
  showTotalVotes: boolean;
  showUserProposer: boolean;
  categoryId: number;

}
